import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgClass } from '@angular/common';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'app-gamification-intro-bottomsheet',
  imports: [
    NgClass
  ],
  templateUrl: './gamification-intro-bottomsheet.component.html',
})
export class GamificationIntroBottomsheetComponent {
  userLanguagePreference: string;
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef,
    protected readonly appConfig: AppConfig,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      languagePreference: string;
      onClose?: () => void
    }
  ) {
    this.userLanguagePreference = this.data.languagePreference;
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
    if (this.data?.onClose) {
      this.data.onClose();
    }
  }
}
